/** Primeiro nome para saudações curtas na home. */
export function firstName(value: string | null | undefined): string {
  if (!value) return "atleta";
  const local = value.split("@")[0]?.split(/[._-]/)[0];
  if (!local) return "atleta";
  return local.charAt(0).toUpperCase() + local.slice(1);
}

/** Formata uma data ISO (YYYY-MM-DD ou timestamp) em dd/mm/aaaa. */
export function formatDate(value: string): string {
  const [year, month, day] = value.slice(0, 10).split("-");
  return year && month && day ? `${day}/${month}/${year}` : value;
}

/** Formata um timestamp ISO em HH:mm no fuso local. */
export function time(value: string): string {
  return new Date(value).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
}
